document.addEventListener('DOMContentLoaded', function () {
  // Convert CSS preloads to stylesheets for async loading
  const mainCssPreload = document.getElementById('main-css-preload');
  const fontsCssPreload = document.getElementById('fonts-css-preload');

  if (mainCssPreload) {
    mainCssPreload.rel = 'stylesheet';
  }
  if (fontsCssPreload) {
    fontsCssPreload.rel = 'stylesheet';
  }

  // Show JavaScript-only elements when JS is available
  document.querySelectorAll('.js-only').forEach((el) => {
    el.classList.remove('js-only');
  });

  // Theme management
  const themeToggle = document.getElementById('themeToggle');
  const themeDropdown = document.getElementById('themeDropdown');
  const themeSystem = document.getElementById('themeSystem');
  const themeLight = document.getElementById('themeLight');
  const themeDark = document.getElementById('themeDark');
  const html = document.documentElement;

  // Mobile theme elements
  const mobileThemeSystem = document.getElementById('mobileThemeSystem');
  const mobileThemeLight = document.getElementById('mobileThemeLight');
  const mobileThemeDark = document.getElementById('mobileThemeDark');

  // Icon elements
  const systemIcon = document.getElementById('systemIcon');
  const sunIcon = document.getElementById('sunIcon');
  const moonIcon = document.getElementById('moonIcon');

  // Check mark elements
  const systemCheck = document.getElementById('systemCheck');
  const lightCheck = document.getElementById('lightCheck');
  const darkCheck = document.getElementById('darkCheck');

  // Mobile check mark elements
  const mobileSystemCheck = document.getElementById('mobileSystemCheck');
  const mobileLightCheck = document.getElementById('mobileLightCheck');
  const mobileDarkCheck = document.getElementById('mobileDarkCheck');

  // Initialize theme
  function updateTheme() {
    const savedTheme = localStorage.getItem('theme');

    // Hide all icons and checkmarks first
    systemIcon.classList.add('hidden');
    sunIcon.classList.add('hidden');
    moonIcon.classList.add('hidden');
    systemCheck.classList.add('hidden');
    lightCheck.classList.add('hidden');
    darkCheck.classList.add('hidden');

    // Hide mobile checkmarks and reset button styles
    if (mobileSystemCheck) mobileSystemCheck.classList.add('hidden');
    if (mobileLightCheck) mobileLightCheck.classList.add('hidden');
    if (mobileDarkCheck) mobileDarkCheck.classList.add('hidden');

    // Reset mobile button styles
    if (mobileThemeSystem) {
      mobileThemeSystem.classList.remove('text-gray-900', 'dark:text-white');
      mobileThemeSystem.classList.add('text-gray-600', 'dark:text-gray-400');
    }
    if (mobileThemeLight) {
      mobileThemeLight.classList.remove('text-gray-900', 'dark:text-white');
      mobileThemeLight.classList.add('text-gray-600', 'dark:text-gray-400');
    }
    if (mobileThemeDark) {
      mobileThemeDark.classList.remove('text-gray-900', 'dark:text-white');
      mobileThemeDark.classList.add('text-gray-600', 'dark:text-gray-400');
    }

    // Remove all theme classes first
    html.classList.remove('light', 'dark', 'system');

    if (savedTheme === 'light') {
      html.classList.add('light');
      sunIcon.classList.remove('hidden');
      lightCheck.classList.remove('hidden');
      // Mobile light theme active state
      if (mobileLightCheck) mobileLightCheck.classList.remove('hidden');
      if (mobileThemeLight) {
        mobileThemeLight.classList.remove(
          'text-gray-600',
          'dark:text-gray-400',
        );
        mobileThemeLight.classList.add('text-gray-900', 'dark:text-white');
      }
    } else if (savedTheme === 'system') {
      // System preference - check current system preference
      const currentSystemPrefersDark = window.matchMedia(
        '(prefers-color-scheme: dark)',
      ).matches;
      html.classList.add('system');
      if (currentSystemPrefersDark) {
        html.classList.add('dark');
      } else {
        html.classList.add('light');
      }
      systemIcon.classList.remove('hidden');
      systemCheck.classList.remove('hidden');
      // Mobile system theme active state
      if (mobileSystemCheck) mobileSystemCheck.classList.remove('hidden');
      if (mobileThemeSystem) {
        mobileThemeSystem.classList.remove(
          'text-gray-600',
          'dark:text-gray-400',
        );
        mobileThemeSystem.classList.add('text-gray-900', 'dark:text-white');
      }
    } else {
      // Default to dark (both when saved as 'dark' and when no theme is set)
      if (!savedTheme) {
        localStorage.setItem('theme', 'dark');
      }
      html.classList.add('dark');
      moonIcon.classList.remove('hidden');
      darkCheck.classList.remove('hidden');
      // Mobile dark theme active state
      if (mobileDarkCheck) mobileDarkCheck.classList.remove('hidden');
      if (mobileThemeDark) {
        mobileThemeDark.classList.remove('text-gray-600', 'dark:text-gray-400');
        mobileThemeDark.classList.add('text-gray-900', 'dark:text-white');
      }
    }
  }

  // Initialize theme on load
  updateTheme();

  // Theme toggle dropdown functionality
  if (themeToggle && themeDropdown) {
    themeToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      themeDropdown.classList.toggle('hidden');
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function (e) {
      if (
        !themeToggle.contains(e.target) &&
        !themeDropdown.contains(e.target)
      ) {
        themeDropdown.classList.add('hidden');
      }
    });
  }

  // Theme option handlers
  if (themeSystem) {
    themeSystem.addEventListener('click', function () {
      localStorage.setItem('theme', 'system');
      themeDropdown.classList.add('hidden');
      updateTheme();
    });
  }

  if (themeLight) {
    themeLight.addEventListener('click', function () {
      localStorage.setItem('theme', 'light');
      themeDropdown.classList.add('hidden');
      updateTheme();
    });
  }

  if (themeDark) {
    themeDark.addEventListener('click', function () {
      localStorage.setItem('theme', 'dark');
      themeDropdown.classList.add('hidden');
      updateTheme();
    });
  }

  // Mobile theme option handlers
  if (mobileThemeSystem) {
    mobileThemeSystem.addEventListener('click', function () {
      localStorage.setItem('theme', 'system');
      updateTheme();
    });
  }

  if (mobileThemeLight) {
    mobileThemeLight.addEventListener('click', function () {
      localStorage.setItem('theme', 'light');
      updateTheme();
    });
  }

  if (mobileThemeDark) {
    mobileThemeDark.addEventListener('click', function () {
      localStorage.setItem('theme', 'dark');
      updateTheme();
    });
  }

  // Listen for system theme changes
  window
    .matchMedia('(prefers-color-scheme: dark)')
    .addEventListener('change', function () {
      if (localStorage.getItem('theme') === 'system') {
        updateTheme();
      }
    });

  // Register Service Worker
  if ('serviceWorker' in navigator) {
    // A page served by an older worker may be stale cached HTML. Reload once
    // when a new worker takes over so visitors get the current page. First
    // visits (no previous controller) never reload.
    const hadController = Boolean(navigator.serviceWorker.controller);
    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!hadController || reloading) return;
      reloading = true;
      window.location.reload();
    });

    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          // Check for a newer worker now rather than waiting for the browser
          registration.update();
        })
        .catch(() => {
          // console.log('Service Worker registration failed: ', error);
        });
    });
  }
});
